function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import claimConsumablesService from '../../services/claim/claim_consumables.service';
import { useSelector } from 'react-redux';
import claimEmployeeRndApportionmentsService from '../../services/claim/claim_employee_rnd_apportionments.service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import ApportionmentsList from '../ApportionmentsList';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import ItemTypeDropdown from './ItemTypeDropdown';
export function ConsumablesRow(_ref) {
  let {
    sortedClaimProjectReports,
    index,
    claim,
    handleDelete,
    claimConsumables,
    setClaimConsumables,
    refreshClaim,
    totalPayrollCostInvalid,
    handleError,
    headerScrollPosition,
    isShowInvolvement
  } = _ref;
  const [hasError, setHasError] = useState(false);
  const user = useSelector(state => state.auth.user);
  const claimEmployeeRndApportRef = useRef(null);
  useEffect(() => {
    if (claimEmployeeRndApportRef.current) {
      claimEmployeeRndApportRef.current.scrollTo({
        left: headerScrollPosition
      });
    }
  }, [claimEmployeeRndApportRef, headerScrollPosition]);
  const claimConsumable = useMemo(() => {
    return _objectSpread({}, claimConsumables[index]);
  }, [claimConsumables, index]);
  const dispatch = useDispatch();
  const updateConsumables = useCallback(consumable => {
    const newConsumables = [...claimConsumables];
    newConsumables[index] = _objectSpread({}, consumable);
    setClaimConsumables([...newConsumables]);
  }, [claimConsumables, index, setClaimConsumables]);
  const handleApportionmentChange = useErrorHandling(useCallback(async (claimConsumable, apportionment) => {
    const oldApportionment = claimConsumable.claim_employee_rnd_apportionments.find(a => a.claim_project_report_id === apportionment.claim_project_report_id);
    const index = claimConsumable.claim_employee_rnd_apportionments.indexOf(oldApportionment);
    const newApportionments = [...claimConsumable.claim_employee_rnd_apportionments];
    if (index === -1) {
      newApportionments.push(apportionment);
    } else {
      newApportionments[index] = _objectSpread({}, apportionment);
    }
    const updatedClaimConsumable = await claimConsumablesService.get(claimConsumable);
    updatedClaimConsumable.claim_employee_rnd_apportionments = newApportionments;
    updateConsumables(updatedClaimConsumable);
  }, [updateConsumables]));
  const handleChange = useCallback(event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimConsumable[event.target.name] = value;
    updateConsumables(claimConsumable);
  }, [updateConsumables, claimConsumable]);
  const saveChange = useCallback(() => {
    let method;
    if (claimConsumable.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimConsumablesService[method](claimConsumable).then(updateConsumable => {
      setHasError(false);
      updateConsumables(updateConsumable);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateConsumables, claimConsumable, dispatch, refreshClaim]);
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "name",
    object: _objectSpread(_objectSpread({}, claimConsumable), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimConsumable.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "net_amount",
    object: _objectSpread(_objectSpread({}, claimConsumable), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimConsumable.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(ItemTypeDropdown, {
    claim: claim,
    claimConsumable: claimConsumable,
    userUnauthorizedToEdit: !hasPermissions(),
    onChange: handleChange,
    onBlur: saveChange
  })), isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimConsumable), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimConsumable.claim)
    }),
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "direct_rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimConsumable), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimConsumable.claim)
    }),
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "indirect_rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions() || claim.claim_group.project_methodology !== 'employee_basis',
    name: "rnd_apportionment",
    className: totalPayrollCostInvalid && claimConsumable.item_type === 'Utilities' ? 'border-warning' : null,
    object: _objectSpread(_objectSpread({}, claimConsumable), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimConsumable.claim)
    }),
    size: "sm",
    type: "text"
  }))), claim.claim_group.project_methodology === 'project_basis' && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ApportionmentsList, {
    claim: claim,
    sortedClaimProjectReports: sortedClaimProjectReports,
    headerScrollPosition: headerScrollPosition,
    claimEmployeeRndApportRef: claimEmployeeRndApportRef,
    handleApportionmentChange: handleApportionmentChange,
    claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService,
    model: claimConsumable,
    apportionmentable_type: "UkSection::ClaimConsumable",
    isShowInvolvement: isShowInvolvement
  })), !isShowInvolvement && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions() || claim.claim_group.project_methodology !== 'employee_basis',
    name: "rnd_apportionment",
    className: totalPayrollCostInvalid && claimConsumable.item_type === 'Utilities' ? 'border-warning' : null,
    object: _objectSpread(_objectSpread({}, claimConsumable), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimConsumable.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    disabled: true || !hasPermissions(),
    name: "rnd_amount",
    object: _objectSpread(_objectSpread({}, claimConsumable), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimConsumable.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, claimConsumable.item_type === 'Consumables' && /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    onChange: async e => {
      await handleChange(e);
      saveChange();
    },
    as: Form.Check,
    name: "group_as_various",
    disabled: claim.financials_locked || !hasPermissions(),
    object: _objectSpread(_objectSpread({}, claimConsumable), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimConsumable.claim)
    })
  })), /*#__PURE__*/React.createElement("td", null, hasPermissions() && /*#__PURE__*/React.createElement(DeleteButton, {
    style: {
      height: '28px'
    },
    iconClassName: "text-danger fa-2x",
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set,
    isImmutableUnderReview: true,
    onClick: handleDelete
  }))));
}